.editor {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  min-width: 0;
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-2) var(--space-4);
}

.jump {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.jumpLink {
  color: var(--graphite);
  font: var(--t-small);
  text-decoration: underline;
}

.jumpLink:focus-visible {
  outline: var(--focus-ring);
}

.saveState {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
  font-variant-numeric: tabular-nums;
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  scroll-margin-top: var(--space-7);
}

.heading {
  color: var(--ink);
  font: var(--t-body-strong);
}

.hint {
  color: var(--graphite);
  font: var(--t-small);
}

.text {
  width: 100%;
  min-height: 72px;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
  line-height: 1.55;
  resize: vertical;
}

.text[data-focused] {
  outline: var(--focus-ring);
  outline-offset: 0;
  border-color: var(--brand);
}

.text[readonly] {
  border-color: transparent;
  background: var(--wash);
}
